import React from 'react';
import PropTypes from 'prop-types';
import './analytics-icon.scss';

function CloseIcon({ onClick }) {
    return (
        <span onClick={onClick} className='analytics-icon'>
            <svg
                focusable='false'
                viewBox='0 0 24 24'
                aria-hidden='true'
                tabIndex='-1'
                title='Sync'>
                <path fill="white"
                    d='M18.3 5.71a.9959.9959 0 00-1.41 0L12 10.59 7.11 5.7a.9959.9959 0 00-1.41 0c-.39.39-.39 1.02 0 1.41L10.59 12 5.7 16.89c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L12 13.41l4.89 4.89c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L13.41 12l4.89-4.89c.38-.38.38-1.02 0-1.4z'>
                </path>
            </svg>
        </span>
    );
}


CloseIcon.propTypes = {
    onClick: PropTypes.func
};

export default CloseIcon;
